import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ThreadDefaultView } from './views/ThreadDefaultView';
import { DefaultView, Views } from '../../types/BlockWithViews';

type ThreadBlockBlockProps = Views<DefaultView<ThreadDefaultView>>;

function Thread({ views }: ThreadBlockBlockProps) {
  return <ThreadDefaultView {...views.default} />;
}

export const ThreadBlock = asFetchableBlock(Thread, BlockType.thread);
export type ThreadBlock = ComponentProps<typeof ThreadBlock>;
